import { render, staticRenderFns } from "./RegisterCertificateDialog.vue?vue&type=template&id=68374ed6&scoped=true&"
import script from "./RegisterCertificateDialog.vue?vue&type=script&lang=ts&"
export * from "./RegisterCertificateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterCertificateDialog.vue?vue&type=style&index=0&id=68374ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68374ed6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
